<script setup lang="ts">

import GroupingBrandingSlider from "@/grouping/components/GroupingBrandingSlider.vue";
import {Skeleton} from "@/core/components/ui/skeleton";
import GroupingBranding from "@/core/interfaces/laboratory/GroupingBranding";
import {computed} from "vue";

const props = defineProps<{
    isLoading: boolean;
    branding?: GroupingBranding;
}>();

const slider = computed(() => {
    return props.branding?.sliders?.find(slider => slider.type.slug === 'grouping');
});
</script>

<template>
  <div class="relative">
    <div v-if="isLoading" class="relative">
      <div class="relative bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <div class="mb-6">
          <Skeleton class="w-48 h-8 rounded-lg mb-2" />
          <Skeleton class="w-20 h-1 rounded-full" />
        </div>
        <Skeleton class="w-full h-64 rounded-2xl" />
      </div>
    </div>

    <div v-else-if="slider" class="relative">
      <div class="relative bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <div class="mb-6">
          <h2 class="text-2xl font-bold text-gray-900 mb-2">
            Actualités & Événements
          </h2>
          <div class="w-20 h-1 gradient rounded-full" />
        </div>
        <GroupingBrandingSlider :slider="slider" />
      </div>
    </div>

    <div v-else-if="!isLoading && !slider" class="relative">
      <div class="relative bg-white rounded-3xl shadow-xl p-8 border border-gray-100">
        <div class="text-center py-8">
          <div class="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
            <svg class="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <h3 class="text-lg font-medium text-gray-500 mb-1">
            Actualités à venir
          </h3>
          <p class="text-sm text-gray-400">
            Les actualités de votre groupement apparaîtront ici prochainement.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
